let Swiper, Navigation, SliderNavigationHelper;

export default class SliderProductTip {
    static inject(swiper, navigation, sliderNavigationHelper) {
        Swiper = swiper;
        Navigation = navigation;
        SliderNavigationHelper = sliderNavigationHelper;
    }

    constructor(item) {
        this.xMousePos = 0;
        this.yMousePos = 0;
        this.lastScrolledTop = 0;
        this.lastControl = 'next';

        this.createSwiper(item);
    }

    createSwiper(item) {
        var producttipSliderContainer = item.querySelectorAll(".producttipSliderContainer")[0];
        var next = item.querySelectorAll(".swiper-button-next")[0];
        var prev = item.querySelectorAll(".swiper-button-prev")[0];
        var breakpointsConfiguration;

        if (producttipSliderContainer.classList.contains('benefitsSlider')) {
            breakpointsConfiguration = {
                //.5 ist wichtig um Sliderbug zu verhindern
                1200.5: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                992.5: {
                    slidesPerView: 2,
                    spaceBetween: 40
                },
                768.5: {
                    slidesPerView: 2,
                    spaceBetween: 40
                },
            }
        } else {
            breakpointsConfiguration = {
                //.5 ist wichtig um Sliderbug zu verhindern
                1200.5: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
                992.5: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                768.5: {
                    slidesPerView: 2,
                    spaceBetween: 40
                },
            }
        }

        var snh = new SliderNavigationHelper();
        snh.addFollowMouseListener(next, prev, item);

        var swiper = new Swiper(producttipSliderContainer, {
            modules: [ Navigation ],
            watchOverflow: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            slidesPerView: 1,
            spaceBetween: 40,
            breakpoints: breakpointsConfiguration
        });
        this.swiper = swiper;
    }
}
